(function(){
    'use strict'

    angular
    .module('app.paquetes')
    .controller('paquetes.List', List);

    List.$inject = ['$animationsSrv', 'ApiBaseService', 'logger', '$location', 'UserInfoService'];

    function List($animationsSrv, ApiBaseService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();

        var permisosPaquetes = UserInfoService.getPermisosPaquetes();

        var vm = this;

        vm.uiData = {
            puedeGuardar: permisosPaquetes.guardar === true,
            puedeModificar: permisosPaquetes.modificar === true,
            puedeEliminar: permisosPaquetes.eliminar === true
        };

        vm.collection = [];
        vm.title = 'Paquetes';

        vm.goToEdit = function(data){
            
            var path = '/editar-paquete/';

            if(data){
                $location.path(path + data.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        function getRemoteController()
        {
            if(UserInfoService.esOrganizador())
            {
                return 'api/Paquetes/All';
            }

            return null;
        }

        getAll();

        function getAll(){
            ApiBaseService.remoteController = getRemoteController();
            var promise = ApiBaseService.getAll([]);

            promise
            .then(function(collection){
                vm.collection = collection;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        vm.delete = function(data){
            ApiBaseService.remoteController = 'api/Paquetes';
            var promise = ApiBaseService.remove(data);
            
            promise
            .then(function(response){
                vm.collection = vm.collection.filter(function(g) {
                    return g.id !== data.id;
                });
                logger.success('Registro eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Registro');
                        break;
                }
                
            });   
        };

    }
})();